export const FETCH_COMPANY = 'FETCH_COMPANY';
export const FILTER_COMPANY = 'FILTER_COMPANY';